import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fi from '../../locales/fi.yml';
import en from '../../locales/en.yml';

const i18nConfig = {
  lng: 'fi',
  fallbackLng: 'fi',
  ns: ['translations'],
  defaultNS: 'translations',
  resources: {
    en: { translations: en.en },
    fi: { translations: fi.fi }
  },
  interpolation: {
    escapeValue: false
  },
  react: {
    useSuspense: false
  },
  parseMissingKeyHandler: () => undefined
};

i18n.use(initReactI18next).init(i18nConfig);

i18n.on('languageChanged', (lng: string) => {
  window.OneTrust?.changeLanguage?.(lng);
});

declare global {
  interface Window {
    OneTrust?: {
      changeLanguage?: (lng: string) => void;
    };
  }
}

export default i18n;
